export default "__VITE_ASSET__D9i37jgY__"